import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { addLodger, deleteLodger, getApartments, getCard, deleteCard, getFeedbackItem,
  getFeedbackList, getNotification, getPaymentInfo, getPayments,
  newAdRequest, notificationIsRead, page, pay, pinApartment, postFeedback,
  sendMessage, unpinApartment, updateAdRequest, checkNewNotification,
  getPaymentInfoPay, cancelRentAdRequest, resendConfirmationEmail } from '@/services/api';
import { Feedback, IPageProfileTranslation, IProfilePage,
  Notifications, PaymentsApartment, PaymentsCommunal, PaymentsTransaction, PaymentsRental,
  Profile, QueryForTable, ApartmentData, InfinityQuery, FeedbackList } from '@/types';
import Vue from 'vue';

const rawError: boolean = true;

@Module({namespaced: true})
export default class ProfilePage extends VuexModule implements IProfilePage {
  public translation: IPageProfileTranslation = {
    contact: {},
    edit: {},
    personal_data: {
      photo_text: '',
      rows: [],
      email_popup: {
        title: '',
        btn_text: '',
      },
      phone_popup: {
        title: '',
        subTitle: '',
        buttonText: '',
        hint: '',
        errorEmptyCode: '',
      },
      edit_btn: '',
      edit_back_btn: '',
      errorsMessages: {
        passwordNotMatch: '',
        fieldRequired: '',
        emailWrong: '',
        phoneWrong: '',
        agreementNotConfirm: '',
        innerError: '',
      },
      resend_email: '',
      resend_successful: '',
    },
    change_password: {},
    credit_card: {},
    my_apartments: {
      rent_ad_request: {},
      prolong_close: {
        prolong: {
          title: '',
          subtitle: '',
          new_start_label: '',
          period_label: '',
          check_data_subtitle: '',
          apartment_label: '',
          new_lease_period_label: '',
          rent_price: '',
          buttons: {
            cancel: '',
            send_request: '',
          },
          info_block: {
            title: '',
            text: '',
            phone: '',
            email: '',
          },
          thank_you: {
            text_first: '',
            text_second: '',
            button: '',
          },
        },
        close: {
          title: '',
          subtitle: '',
          old_end_label: '',
          new_end_label: '',
          reason_subtitle: '',
          reason_placeholder: '',
          new_lease_period_label: '',
          buttons: {
            cancel: '',
            send_request: '',
          },
          info_block: {
            title: '',
            text: '',
            text_second: '',
            subtitle: '',
            phone: '',
            email: '',
          },
          thank_you: {
            text_first: '',
            text_second: '',
            button: '',
          },
        },
      },
      buttons: {
        back_btn: '',
        back_btn_text: '',
        create_ad_btn: '',
        edit_ad_btn: '',
        prolong_btn: '',
        close_btn: '',
        change_terms_btn: '',
        detail_btn: '',
        deactivate_btn: '',
        payments_btn: '',
      },
      change_terms: {
        title: '',
        subtitle: '',
        info: '',
        info_block: {
          title: '',
          text: '',
          phone: '',
          email: '',
        },
        price_block: {
          title: '',
          description: '',
          recommended_price: '',
          price_hint: '',
          rent_price: '',
          currency: '',
          standard_one_service: '',
          month_income: '',
          tax_hint: '',
        },
        date_block: {
          start_date: '',
          end_date: '',
        },
        check_data_subtitle: '',
        apartment_label: '',
        new_lease_period_label: '',
        rent_price: '',
        buttons: {
          cancel: '',
          send_request: '',
        },
      },
    },
    notifications_input_placeholder: '',
    support: {},
    feedback: {},
    dashboard: {
      title: '',
      apartmentsBlock: {},
      notificationsBlock: {},
      paymentsBlock: {},
      rulesBlock: {},
      servicesBlock: {},
      lodgersBlock: {
        title: '',
        owner: '',
        lodger: '',
        renter: '',
        add: '',
        back: '',
        showAll: '',
        modalAdd: {
          text: '',
          error: '',
          placeholder: '',
          btnText: '',
        },
        modalAddThankYou: {
          text: '',
          btnText: '',
        },
        modalDelete: {
          text: '',
          btnText: '',
          btnCancel: '',
        },
        modalDeleteThankYou: {
          text: '',
          btnText: '',
        },
      },
      statsBlock: {},
    },
    payments: {
      apartment: '',
      name: '',
      payment_date: '',
      total: '',
      status: '',
      action: '',
      pay: '',
      statuses: {},
      details: '',
      communal_payments_include: '',
      date_until: '',
      close: '',
      back_to_payments: '',
      successful_payment: '',
      payer_title: '',
      payer: {
        renter: 'Арендатор',
        owner: 'Владелец',
        you: 'Ви',
        lodger: 'Мешканець',
      },
    },
  };
  public apartments: ApartmentData[] = [];
  public feedbackList: FeedbackList = {
    search: '',
    ordering: '',
    count: 0,
    current_page: 0,
    links: {},
    next_page: null,
    previous_page: null,
    results: [],
  };
  public feedbackItem: Feedback = {
    created_at: '',
    documents: [],
    id: '',
    messages: [],
    number: 0,
    photos: [],
    status: '',
    status_description: '',
    text: '',
    theme_name: '',
    title: '',
  };
  public notifications: Notifications = {
    count: 0,
    current_page: 0,
    links: {},
    next_page: 0,
    previous_page: 0,
    results: [],
  };
  public newNotifications: boolean = false;
  public adCreationStepNumber: number = 0;
  public paymentsRental: PaymentsRental = {
    ordering: '',
    query: {
      links: {
        next: null,
        previous: null,
      },
      count: 0,
      results: [],
      current_page: 0,
      next_page: null,
      previous_page: null,
    },
  };
  public paymentsCommunal: PaymentsCommunal = {
    ordering: '',
    query: {
      links: {
        next: null,
        previous: null,
      },
      count: 0,
      results: [],
      current_page: 0,
      next_page: null,
      previous_page: null,
    },
  };

  public paymentsApartment: PaymentsApartment = {
    ordering: '',
    query: {
      links: {
        next: null,
        previous: null,
      },
      count: 0,
      results: [],
      current_page: 0,
      next_page: null,
      previous_page: null,
    },
  };

  public get rentalPayments(): PaymentsRental {
    return this.paymentsRental;
  }

  public get communalPayments(): PaymentsCommunal {
    return this.paymentsCommunal;
  }

  public get apartmentPayments(): PaymentsApartment {
    return this.paymentsApartment;
  }

  public get paymentsTranslation(): PaymentsTransaction {
    return this.translation.payments;
  }

  public get contact(): {} {
    return this.translation.contact;
  }

  public get edit(): {} {
    return this.translation.edit;
  }

  public get personalData(): {} {
    return this.translation.personal_data;
  }

  public get changePassword(): {} {
    return this.translation.change_password;
  }

  public get myApartmentsTexts(): {} {
    return this.translation.my_apartments;
  }

  public get myNotificationsTexts(): {} {
    return this.translation.notifications_input_placeholder;
  }

  public get myApartments(): {} {
    return this.apartments;
  }

  public get getNotifications(): Notifications {
    return this.notifications;
  }

  public get getSupportTexts(): {} {
    return this.translation.support;
  }

  public get getFeedbackList(): {} {
    return this.feedbackList;
  }

  public get actualFeedback(): {} {
    return this.feedbackItem;
  }

  public get feedbackItemText(): {} {
    return this.translation.feedback;
  }

  public get dashboardTexts(): {} {
    return this.translation.dashboard;
  }

  public get createAdTexts(): {} {
    return this.translation.my_apartments.rent_ad_request;
  }

  public get stepNumber(): {} {
    return this.adCreationStepNumber;
  }

  public get creditCardTexts(): {} {
    return this.translation.credit_card;
  }

  public get lodgersBlockTexts(): {} {
    return this.translation.dashboard.lodgersBlock;
  }

  public get isNewNotification(): {} {
    return this.newNotifications;
  }

  public get prolongCloseTexts(): {} {
    return this.translation.my_apartments.prolong_close;
  }

  public get changeTermsTexts(): {} {
    return this.translation.my_apartments.change_terms;
  }

  @Mutation
  public [Profile.SET_PROFILE_TRANSLATION](payload: IPageProfileTranslation): void {
    this.translation = payload;
  }

  @Mutation
  public [Profile.SET_RENTAL_PAYMENTS](payload: PaymentsRental): void {
    this.paymentsRental = payload;
  }

  @Mutation
  public [Profile.CLEAR_RENTAL_PAYMENTS](): void {
    this.paymentsRental = {
      ordering: '',
      query: {
        links: {
          next: null,
          previous: null,
        },
        count: 0,
        results: [],
        current_page: 0,
        next_page: null,
        previous_page: null,
      },
    };
  }

  @Mutation
  public [Profile.SET_APARTMENT_PAYMENTS](payload: PaymentsApartment): void {
    this.paymentsApartment = payload;
  }

  @Mutation
  public [Profile.CLEAR_APARTMENT_PAYMENTS](): void {
    this.paymentsApartment = {
      ordering: '',
      query: {
        links: {
          next: null,
          previous: null,
        },
        count: 0,
        results: [],
        current_page: 0,
        next_page: null,
        previous_page: null,
      },
    };
  }

  @Mutation
  public [Profile.SET_COMMUNAL_PAYMENTS](payload: PaymentsCommunal): void {
    this.paymentsCommunal = payload;
  }

  @Mutation
  public [Profile.SET_PROFILE_APARTMENTS](payload: ApartmentData[]): void {
    this.apartments = payload;
  }

  @Mutation
  public [Profile.TOGGLE_FAVORITE_APARTMENTS](payload): void {
    for (const apartment in this.apartments) {
      if (this.apartments[apartment].id === payload.id) {
        this.apartments[apartment].favourite = payload.favourite;
      }
    }
  }

  @Mutation
  public [Profile.SET_NOTIFICATIONS](payload: Notifications): void {
    this.notifications = payload;
  }

  @Mutation
  public [Profile.CHECK_NOTIFICATIONS](payload): void {
    this.newNotifications = payload.new;
  }

  @Mutation
  public [Profile.CLEAR_NOTIFICATIONS](): void {
    this.notifications = {
      count: 0,
      current_page: 0,
      links: {},
      next_page: 0,
      previous_page: null,
      results: [],
    };
  }

  @Mutation
  public [Profile.READ_NOTIFICATIONS](payload): void {
    for (const notification in this.notifications.results) {
      if (this.notifications.results[notification].id === payload.id) {
        this.notifications.results[notification] = payload;
        break;
      }
    }
  }

  @Mutation
  public [Profile.UPDATE_MESSAGES](payload): void {
    this.feedbackItem = payload;
  }

  @Mutation
  public [Profile.SET_FEEDBACK_LIST](payload: FeedbackList): void {
    if (payload.current_page > 1) {
      const newList = {
        ...this.feedbackList,
        ...payload,
        results: [
          ...this.feedbackList.results,
          ...payload.results,
        ],
      };
      this.feedbackList = newList;
    } else {
      this.feedbackList = {...this.feedbackList, ...payload};
    }
  }

  @Mutation
  public [Profile.SET_FEEDBACK_ITEM](payload): void {
    this.feedbackItem = payload;
  }

  @Mutation
  public [Profile.CLEAR_FEEDBACK_ITEM](): void {
    this.feedbackItem = {
      created_at: '',
      documents: [],
      id: '',
      messages: [],
      number: 0,
      photos: [],
      status: '',
      status_description: '',
      text: '',
      theme_name: '',
      title: '',
    };
  }

  @Mutation
  public [Profile.ADD_STEP_NUMBER](): void {
    this.adCreationStepNumber++;
  }

  @Mutation
  public [Profile.DEC_STEP_NUMBER](): void {
    this.adCreationStepNumber--;
  }

  @Mutation
  public [Profile.CLEAR_STEP_NUMBER](): void {
    this.adCreationStepNumber = 0;
  }

  @Mutation
  public [Profile.UPDATE_APARTMENTS](payload): void {
    this.apartments = payload;
  }

  @Mutation
  public [Profile.UPDATE_COMMUNAL_PAYMENTS](payload): void {
    this.paymentsCommunal.query.results = payload;
  }

  @Mutation
  public [Profile.UPDATE_RENTAL_PAYMENTS](payload): void {
    this.paymentsRental.query.results = payload;
  }

  @Mutation
  public [Profile.UPDATE_APARTMENT_PAYMENTS](payload): void {
    this.paymentsApartment.query.results = payload;
  }

  @Mutation
  public [Profile.CLEAR_COMUNAL_PAYMENTS](): void {
    this.paymentsCommunal = {
      ordering: '',
      query: {
        links: {
          next: null,
          previous: null,
        },
        count: 0,
        results: [],
        current_page: 0,
        next_page: null,
        previous_page: null,
      },
    };
  }

  @Mutation
  public [Profile.SET_RENTAL_ORDERING](payload: string): void {
    this.paymentsRental.ordering = payload;
  }

  @Mutation
  public [Profile.SET_COMMUNAL_ORDERING](payload: string): void {
    this.paymentsCommunal.ordering = payload;
  }

  @Mutation
  public [Profile.SET_APARTMENT_ORDERING](payload: string): void {
    this.paymentsApartment.ordering = payload;
  }

  @Mutation
  public [Profile.UPDATE_RENT_AD_REQUEST](data): void {
    this.apartments.forEach((apartment) => {
      if (apartment.id === data.id) {
        apartment.rent_ad_request = data.value;
      }
    });
  }

  @Action({commit: Profile.SET_PROFILE_TRANSLATION, rawError})
  public async fetchTranslation() {
    const data = await page('profile');
    return data ? { ...this.translation, ...data } : this.translation;
  }

  @Action({commit: Profile.SET_PROFILE_APARTMENTS, rawError})
  public async fetchApartments() {
    const data = await getApartments();
    return data ? data : this.apartments;
  }

  @Action({commit: Profile.TOGGLE_FAVORITE_APARTMENTS, rawError})
  public async toggleFavorite(data) {
    const response = data.status ? await unpinApartment(data.id) : await pinApartment(data.id);
    return response;
  }

  @Action({commit: Profile.SET_NOTIFICATIONS, rawError})
  public async fetchNotifications(query): Promise<Notifications> {
    const response = await getNotification(query);
    if (response.status === 200 && !!response.data) {
      return !this.notifications.results.length
        ? response.data
        : {...response.data, results: [...this.notifications.results, ...response.data.results]};
    } else {
      return this.notifications;
    }
  }

  @Action({commit: Profile.READ_NOTIFICATIONS, rawError})
  public async makeNotificationRead(id) {
    const response = await notificationIsRead(id);
    return response.data;
  }

  @Action({commit: Profile.CHECK_NOTIFICATIONS, rawError})
  public async checkNotification() {
    const response = await checkNewNotification();
    return response ? response.data : false;
  }

  @Action({commit: Profile.SET_FEEDBACK_LIST, rawError})
  public async fetchFeedbackList(query) {
    const response = await getFeedbackList(query);
    return response ? response.data : this.feedbackList;
  }

  @Action
  public createFeedback(data) {
    return postFeedback(data);
  }

  @Action({commit: Profile.SET_FEEDBACK_ITEM, rawError})
  public async fetchFeedback(id) {
    const response = await getFeedbackItem(id);
    return response ? response.data : this.feedbackItem;
  }

  @Action({rawError})
  public async createNewMessage(data) {
    const response = await sendMessage(data.id, data.files);
    if (response.status === 200) {
      this.context.commit(Profile.UPDATE_MESSAGES, response.data);
      return response;
    } else {
      return response;
    }
  }

  @Action({commit: Profile.CLEAR_FEEDBACK_ITEM, rawError})
  public async clearSupportData() {}

  @Action({commit: Profile.ADD_STEP_NUMBER, rawError})
  public async addStepNumber() {}

  @Action({commit: Profile.DEC_STEP_NUMBER, rawError})
  public async decrementStepNumber() {}

  @Action({commit: Profile.CLEAR_STEP_NUMBER, rawError})
  public async clearStepNumber() {}

  @Action
  public async sendAdRequest(data) {
    let response;
    try {
      response = data.update ? await updateAdRequest(data) : await newAdRequest(data);
      if (response.responseApartment.status === 200 && response.responseRent.status === 200) {
        this.context.dispatch('updateApartmentData', response.responseApartment.data);
      }
    } catch (err) {
      // passs response error to component
    }
    return response;
  }

  @Action({commit: Profile.UPDATE_APARTMENTS, rawError})
  public updateApartmentData(response) {
    if (this.apartments?.length > 0) {
      return this.apartments.map((it) => {
        if (it.id === response.id) {
          return {
            ...it,
            ...response,
          };
        } else {
          return  {...it};
        }
      });
    }
  }

  @Action({commit: Profile.SET_RENTAL_ORDERING, rawError})
  public setRentalOrdering(value: string) {
    return value || '';
  }

  @Action({commit: Profile.SET_COMMUNAL_ORDERING, rawError})
  public setCommunalOrdering(value: string) {
    return value || '';
  }

  @Action({commit: Profile.SET_APARTMENT_ORDERING, rawError})
  public setApartmentOrdering(value: string) {
    return value || '';
  }

  @Action({rawError})
  public async getCardData(order) {
    const response = await getCard(order);
    return response;
  }

  @Action({rawError})
  public async deleteCard() {
    const response = await deleteCard();
    return response;
  }

  @Action({rawError})
  public async checkCard(id) {
    const response = await getPaymentInfo(id);
    return response;
  }

  @Action({rawError})
  public async checkPaymentInfo(id) {
    return await getPaymentInfoPay(id);
  }

  @Action({commit: Profile.SET_RENTAL_PAYMENTS, rawError})
  public async getRentPayments(query: QueryForTable) {
    const response = await getPayments({name: 'rental', query});
    return !response
      ? this.paymentsRental
      : {
        ordering: query.ordering,
        query: {
          ...response,
          results: [
            ...this.paymentsRental.query.results,
            ...response.results,
          ],
        },
      };
  }

  @Action({commit: Profile.SET_APARTMENT_PAYMENTS, rawError})
  public async getApartmentPayments(query: QueryForTable) {
    const response = await getPayments({name: null, query});
    return !response
      ? this.paymentsApartment
      : {
        ordering: query.ordering,
        query: {
          ...response,
          results: [
            ...this.paymentsApartment.query.results,
            ...response.results,
          ],
        },
      };
  }

  @Action({commit: Profile.SET_COMMUNAL_PAYMENTS, rawError})
  public async getCommunalPayments(query: QueryForTable) {
    const response = await getPayments({name: 'communal', query});
    return !response
      ? this.paymentsCommunal
      : {
        ordering: query.ordering,
        query: {
          ...response,
          results: [
            ...this.paymentsCommunal.query.results,
            ...response.results,
          ],
        },
      };
  }

  @Action({commit: Profile.CLEAR_NOTIFICATIONS, rawError})
  public clearNotifications() {}

  @Action({commit: Profile.CLEAR_RENTAL_PAYMENTS, rawError})
  public clearRentalPayments() {}

  @Action({commit: Profile.CLEAR_COMUNAL_PAYMENTS, rawError})
  public clearComunalPayments() {}


  @Action({commit: Profile.UPDATE_RENTAL_PAYMENTS, rawError})
  public updateRentPayments(response) {
    return this.paymentsRental.query.results.map((item) => {
      return item.id === response.payment.id ? response.payment : item;
    });
  }

  @Action({commit: Profile.UPDATE_COMMUNAL_PAYMENTS, rawError})
  public updateCommunalPayments(response) {
    return this.paymentsCommunal.query.results.map((item) => {
      return item.id === response.payment.id ? response.payment : item;
    });
  }

  @Action({commit: Profile.UPDATE_APARTMENT_PAYMENTS, rawError})
  public updateApartmentPayments(response) {
    return this.paymentsApartment.query.results.map((item) => {
      return item.id === response.payment.id ? response.payment : item;
    });
  }

  @Action({commit: Profile.CLEAR_APARTMENT_PAYMENTS, rawError})
  public clearApartmentPayments() {}

  @Action
  public pay(data) {
    return pay(data.id).then((response) => {
      if (response.status === 200 && !response.data.form) {
        if (data.type === 'paymentsRent') {
          this.context.dispatch('updateRentPayments', response.data);
        } else if (data.type === 'paymentsCommunal') {
          this.context.dispatch('updateCommunalPayments', response.data);
        } else if (data.type === 'apartmentPayments') {
          this.context.dispatch('updateApartmentPayments', response.data);
        }
      }
      return response;
    });
  }

  @Action
  public async sendLodger(data) {
    const response = await addLodger(data);
    return response;
  }

  @Action({rawError})
  public async deleteLodgerFromApart(data) {
    const response = await deleteLodger(data);
    this.context.dispatch('updateApartmentData', response.data);
    return response;
  }

  @Action({rawError})
  public async cancelRentAd(data) {
    const response = await cancelRentAdRequest(data.adId);
    if (response.status === 200) {
      this.context.dispatch('updateApartmentList', {id: data.apartmentId, value: response.data});
    }
    return response;
  }

  @Action({commit: Profile.UPDATE_RENT_AD_REQUEST, rawError})
  public updateApartmentList(data) {
    return data;
  }

  @Action({rawError})
  public resendConfirmationForEmail() {
    return resendConfirmationEmail();
  }

  @Action({commit: 'SET_FEEDBACK_LIST', rawError})
  public clearFeedbakList(): FeedbackList {
    return {
      search: '',
      ordering: '',
      count: 0,
      current_page: 0,
      links: {},
      next_page: null,
      previous_page: null,
      results: [],
    };
  }
}
